import clsx from "clsx";

import HighRisk from "@assets/images/highrisk.svg";

const HighRiskIcon: React.FC<{
  isHighRisk?: boolean;
  className?: string;
}> = (props) => {
  if (!props?.isHighRisk) return null;

  return (
    <span
      role="status"
      aria-label="High Risk"
      title="High Risk"
      className={clsx(
        "ml-1 inline-flex max-w-full items-center gap-1 rounded-full border border-[#FECACA]",
        "bg-gradient-to-r from-[#FEF2F2] via-[#FEE2E2] to-[#FFF1F1]",
        "px-2 py-[2px] align-middle shadow-[0_1px_2px_rgba(239,3,3,0.12)]",
        props?.className,
      )}
    >
      <img
        src={HighRisk}
        alt="High Risk"
        className="h-3 w-3 shrink-0 drop-shadow-[0_1px_1px_rgba(239,3,3,0.25)]"
      />
      <span className="truncate text-[0.6875rem] font-semibold leading-[1.2] text-[#EF0303]">
        High Risk
      </span>
    </span>
  );
};

export default HighRiskIcon;
